declare var $:any
import { Component, OnInit,ViewChild,HostListener } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import * as alertFunctions from '../shared/data/sweet-alerts';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonService } from '../shared/common.service';
import { environment } from '../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-visitgriddetails',
  templateUrl: './visitgriddetails.component.html',
  styleUrls: ['./visitgriddetails.component.css'],
  providers: [CommonService]
})
export class VisitgriddetailsComponent implements OnInit {

  public PatientVists: any = [];
  public pdfopen: any = [];
  public LoginType: String = "";
  public _sFirm_No: any;
  public _sSid_No: any;
  public _dSID_Date: any;

  public BranchCode: any;
  public TestCode: any;
  public SIDNo: any;
  public SIDdate: any;
  public Pdfpath:String="";
  public isBranchUser:any;
  public isSuperUser:any;
  public userName : any;
  public selectedBranch : any;
  public referrerCode : any;

  public document:any=[];
  @ViewChild('pdfViewerAutoLoad') pdfViewerAutoLoad;
  constructor(private titleService: Title, private router: Router, private route: ActivatedRoute, private httpclient : HttpClient, private http: CommonService, private modalService: NgbModal) {
    this.titleService.setTitle("Timeline ::")
  }

  ngOnInit(): void {

    // if (
    //   (sessionStorage.getItem("MobileNo") == null || 
    //   sessionStorage.getItem("MobileNo") == "" || 
    //   sessionStorage.getItem("MobileNo") == undefined) &&
    //   (sessionStorage.getItem("PtCode") == null || 
    //   sessionStorage.getItem("PtCode") == "" || 
    //   sessionStorage.getItem("PtCode") == undefined)) {
    //   window.location.href = environment.LoginURL + sessionStorage.getItem("LoginType");
     
    // }
    this.LoginType = sessionStorage.getItem("LoginType");
    this.isBranchUser = sessionStorage.getItem("Branch_User");
    this.isSuperUser = sessionStorage.getItem("Super_User");
    this.userName = sessionStorage.getItem("refcode");
    this.selectedBranch =  sessionStorage.getItem("selectedBranch");

    
    this.referrerCode = "";
    if ((this.isBranchUser == "0")  && (this.isSuperUser == "0") && sessionStorage.getItem("refcode") != null)
        this.referrerCode = sessionStorage.getItem("refcode");
    else if ((this.isSuperUser == "1") && (this.selectedBranch != "ALL"))
        this.referrerCode = this.selectedBranch;
    else if ((this.isSuperUser == "1") && (this.selectedBranch == "ALL") && (sessionStorage.getItem("refcode") != null))
      this.referrerCode = sessionStorage.getItem("refcode");
    else this.referrerCode = "";

   
    var item = {
      "mobile": sessionStorage.getItem("MobileNo") != null ? sessionStorage.getItem("MobileNo") : "",
      "from_Date": "",
      "to_Date": "",
      "branch_Code": "",
      "ref_Code": this.referrerCode,
      "pt_Code": sessionStorage.getItem("PtCode") != null ? sessionStorage.getItem("PtCode") : "",
      "is_Branch_User": this.isBranchUser,
      "is_Super_User": this.isSuperUser,
      "userName": this.userName.trim()
    }

    let path = "visits/patient";
   //this.http.fnShowLoading();
    this.http.POST(path, item).subscribe(data => {
      
     // this.http.fnHideLoading();
      if (data["Timelines"]) {
        var result = data["Timelines"];

        this.PatientVists = result;   



           
        if (sessionStorage.getItem("PatientName") == null || sessionStorage.getItem("PatientName") == "" || sessionStorage.getItem("PatientName") == undefined)
        {
          this.titleService.setTitle("Timeline :: Patient Visit")
        }
        else
        {
          this.titleService.setTitle("Timeline :: " + sessionStorage.getItem("PatientName"))
        }
      }
      else {
        //alertFunctions.typeError("Web Api returned error");
        alertFunctions.typeError("Unable to process the details. Please contact Admin for more details");
        for (var visit in this.PatientVists)
        {
          console.log("data:",visit);
        }
        return false;
      }
    });

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    var height=window.innerHeight;
    $("#myModal").css('height',height+'px');
  }



  getsmartreportvalidation(testname : any)
  {
     var testnamearr = ["RD","US","MR","pt"];
     var records = testnamearr.find(item => item.toUpperCase() == testname.toUpperCase() );
     return records ? true : false;
  }


  getsmartreport(FirmNo, SidNo, SidDate, Test_Code, testName, patientName,SidDateFormatted, type,formatType,include_header_footer)
  {
    var item = {
      "BillNumber": SidNo,
      "BillDate": SidDate.split("/")[2] + SidDate.split("/")[1] + SidDate.split("/")[0],
      "SampleCode": Test_Code,
      "RisCenterId": FirmNo,
      "IncludeHeader" : "1",
      "IncludeIndexPage":"1"
    }


    var httpobj = this.http;
    var xhr = new XMLHttpRequest();
    this.http.fnShowLoading();
    xhr.open('POST', environment.RADIOLOGISTAPI + "getsmartreport", true);
    xhr.responseType = 'json';
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = function (e) {
    
      console.log("status",this.status);
      if (this.status == 200) {
        console.log(this.response);
        window.open(this.response.url, "_blank");
      } 
      else {
      console.error('response: ', this);
      alertFunctions.typeInfo( "Radiology smart reports are available for radiology reports done on or after August 2023 only");
      }
      httpobj.fnHideLoading();
    };
    
    xhr.send(JSON.stringify(item));  

    
  }

  ViewDownloadLabReport(accesstoken,FirmNo, SidNo, SidDate, testName, patientName,SidDateFormatted, No_Report_header_footer,include_header_footer,reportStatus,type) {
    

    let sDate = SidDate.split("/");
    var self=this;
    var item = {
      "sFirm_No": FirmNo,
      "sSid_No": SidNo,
      "dSID_Date": sDate[2] + "/" + sDate[1] + "/" + sDate[0],
      "No_Report_header_footer" : No_Report_header_footer,
      "include_header_footer" : include_header_footer
    }

    var httpobj = this.http;
    var xhr = new XMLHttpRequest();
    this.http.fnShowLoading();
    xhr.open('POST', environment.APIURL + "downloadlabreport", true);
    xhr.responseType = 'arraybuffer';
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader('Authorization', 'Bearer ' + accesstoken);
    xhr.onload = function (e) {
      // Check status      
      console.log("status",this.status);
      if (this.status == 200) {
        // convert response to Blob, then create URL from blob.
        var blob = new Blob([this.response], { type: 'application/pdf' }),
        fileURL = URL.createObjectURL(blob);
        sessionStorage.setItem("pdfURL", fileURL); 
        sessionStorage.setItem("PatientName", patientName); 
        sessionStorage.setItem("SIDDate", SidDateFormatted); 
        sessionStorage.setItem("TestName", testName); 

        if ((type=='view' || type=='download') && reportStatus == 'Partially Completed')
        {
          alertFunctions.typeInfo( "The lab test report is partially completed. A few test results are pending. Please check back after some time to print/download the completed report");
        }
        if (type == 'view')
        {
          window.open("/ReportsPortal/#/pdfviewer");
          httpobj.fnHideLoading();
          //window.open("pdfviewer"); 
        }
          else if (type == 'download')
        {
           var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
          if (isMobile && type=='view') {
            self.pdfViewerAutoLoad.pdfSrc = fileURL; // pdfSrc can be Blob or Uint8Array
            self.pdfViewerAutoLoad.refresh();
            $("#myModal").modal('show');
          }
          else if(type == 'view'){
            window.open(fileURL);
          }
          var file = new Blob([this.response], { type: "application/pdf" });
          var a = document.createElement("a"), url = URL.createObjectURL(file);
          a.href = url;
          
          a.download = FirmNo + SidNo + "_" + SidDateFormatted + ".pdf";
          document.body.appendChild(a);
          a.click();
          }          
        
      } 
      else {
      console.error('response: ', this);
      alertFunctions.typeInfo( testName + "- Currently report is not available. Please contact respective branch for more details !!.");
      }
      httpobj.fnHideLoading();
    };
    
    xhr.send(JSON.stringify(item));  
    
  }

 ViewDownloadRadiologyReport(accesstoken,FirmNo, SidNo, SidDate, Test_Code, testName, patientName,SidDateFormatted, type,formatType,include_header_footer){
   // alert('')
    var self=this;
    var item = {
      "sSid_No": SidNo,
      "dSID_Date": SidDate,
      "test_code": Test_Code,
      "sFirm_No": FirmNo,
      "include_header_footer" : include_header_footer,
      "no_Report_header_footer":include_header_footer
    }
    // if (formatType != 'report'){
    var endPoint = '';
    if (formatType == 'report') 
      endPoint = 'downloadrisreport';
    else 
      endPoint = 'downloadfilms';
    // Send Request
    var httpobj = this.http;
    var xhr = new XMLHttpRequest();
    this.http.fnShowLoading();
    xhr.open('POST', environment.APIURL + endPoint, true);
    xhr.responseType = 'arraybuffer';
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader('Authorization', 'Bearer ' + accesstoken);
    xhr.onload = function (e) {
      // Check status
      if (this.status == 200) {
        // convert response to Blob, then create URL from blob.
        var blob = new Blob([this.response], { type: 'application/pdf' }),
        fileURL = URL.createObjectURL(blob);
        sessionStorage.setItem("pdfURL", fileURL); 
        sessionStorage.setItem("PatientName", patientName); 
        sessionStorage.setItem("SIDDate", SidDateFormatted); 
        sessionStorage.setItem("TestName", testName); 

        if (type=="view")
        {
          window.open("/ReportsPortal/#/pdfviewer");      
          httpobj.fnHideLoading(); 
        }
        else if (type =="download")
        {
          SidDateFormatted = SidDate.split("/")[2] + SidDate.split("/")[1] + SidDate.split("/")[0];
          var file = new Blob([this.response], { type: "application/pdf" });
          var a = document.createElement("a"), url = URL.createObjectURL(file);
          a.href = url;
          document.body.appendChild(a);
          a.download = SidNo + "_" + SidDateFormatted + ".pdf";
          a.click(); 
        }        
       } 
       else {
        console.error('response: ', this);
        alertFunctions.typeInfo(testName + " - Currently report is not available. Please contact respective branch for more details !!.");
      }
      httpobj.fnHideLoading();
    };
    xhr.send(JSON.stringify(item));
  }
// }

  PrintAllDocuments(SidNo,SidDate)
  {
     //console.log("flag - ",$('#chkIncludeHeader_'+ SidNo).is(':checked') );
    //console.log('is Branch user - ',this.isBranchUser);
    var include_header_footer = '1';  
    if (this.isBranchUser == '1')
    {
      //console.log('is Branch user - ', 'true');
      if ($('#chkIncludeHeader_'+ SidNo).is(':checked') == false)
      {
        //console.log('include header - ' ,'false');
        include_header_footer = '0'; 
      }

    }  

    this.PatientVists.forEach( (patientvisit) => {
      patientvisit.visits.forEach((visit) => {
        if (visit.Sid_No == SidNo && visit.Sid_Date == SidDate)
          visit.tests.forEach((test) => {
            if (test.Test_Name == "Lab"  && 
                test.IsManualCollection == 'N' &&
                test.EnablePrint == 'Y')
            {              
              this.ViewDownloadLabReport(
                visit.accesstoken,
                visit.BranchCode,
                visit.Sid_No,
                visit.Sid_Date,
                test.Test_Name,
                visit.PName,
                visit.Sid_Date_Formatted,
                visit.No_Report_header_footer,
                include_header_footer,
                test.Test_Report_Status,
                'download'
              );
            }
            else if (test.Test_Name != "Lab"  && 
            test.IsManualCollection == 'N' &&
            test.EnablePrint == 'Y')
            {
              console.log("coming here",visit.Sid_Date);
              this.ViewDownloadRadiologyReport(
                visit.accesstoken,
                visit.BranchCode,
                visit.Sid_No,
                visit.Sid_Date,
                test.Test_Code,
                test.Test_Name,
                visit.PName,
                visit.Sid_Date_Formatted,
                'download',
                'report',
                include_header_footer
              )
            }
            
          })
      })     
      
  });


    
  }
  ShowErrorMessage(errMsg){
    alertFunctions.typeInfo(errMsg);
}


  open(content) {    
    $("#myModal").modal('show');   
  }
  CalculateHeight(){
    var height=window.innerHeight;
    return height+100;
  }
}
function target(arg0: string, target: any, arg2: string, arg3: boolean) {
  throw new Error('Function not implemented.');
}

